const brand = {
  teal: {
    darker: "#42A08D",
    dark: "#50B49F",
    default: "#63C1AE",
    light: "#9FDCD0",
    lighter: "#DAF5EF",
    lightest: "#EBFAF6",
    background: "#FBFFFE",
  },
  blue: {
    darker: "#4EC4CC",
    dark: "#65D7DF",
    default: "#6EE2EA",
    light: "#81ECF2",
    lighter: "#C3FBFE",
    lightest: "#D6FCFE",
    background: "#F2FEFF",
  },
  orange: {
    darker: "#FF8310",
    dark: "#FF891C",
    default: "#FF9524",
    light: "#FFB872",
    lighter: "#FFE9D3",
    lightest: "#FFF4EA",
    background: "#FFFBF6",
  },
  red: {
    darker: "#E55A5A",
    dark: "#EC6666",
    default: "#F27373",
    light: "#FA9797",
    lighter: "#FFBBBB",
    lightest: "#FFEAEA",
    background: "#FFF8F8",
  },
  gray: {
    darker: "#4D4D4D",
    dark: "#525252",
    default: "#686868",
    light: "#A5A5A5",
    lighter: "#D6D6D6",
    lightest: "#EEEEEE",
    background: "#FAFAFA",
  },
  pink: {
    dark: "#C979A9",
    default: "#D892BC",
    light: "#EDB1D5",
    background: "#FFF8FC",
  },
  brown: {
    dark: "#AE7D31",
    default: "#BF8A38",
    light: "#D29942",
    background: "#F6F2EA",
  },
  yellow: {
    dark: "#FBAF1C",
    default: "#FBB631",
    light: "#F5BF54",
    background: "#FFFCF4",
  },
  green: {
    dark: "#A9C965",
    default: "#BFDA86",
    light: "#D1E5A6",
    background: "#FCFFF6",
  },
  violet: {
    dark: "#8AA7DF",
    default: "#9EB8EA",
    light: "#B3CBF9",
    background: "#F6F9FF",
  },
  purple: {
    dark: "#F6F9FF",
    default: "#B995E5",
    light: "#D0B0F6",
    background: "#FAF6FF",
  },
  system: {
    dark: "#000000",
    default: "#FFFFFF",
  },
};

export const colors = {
  theme: {
    highlights: {
      dark: brand.teal.dark,
      default: brand.teal.default,
      light: brand.teal.light,
      background: brand.teal.background,
    },
    information: {
      dark: brand.blue.dark,
      default: brand.blue.default,
      light: brand.blue.light,
      background: brand.blue.background,
    },
    success: {
      dark: brand.green.dark,
      default: brand.green.default,
      light: brand.green.light,
      background: brand.green.background,
    },
    warning: {
      dark: brand.yellow.dark,
      default: brand.yellow.default,
      light: brand.yellow.light,
      background: brand.yellow.background,
    },
    neutral: {
      darker: brand.gray.darker,
      dark: brand.gray.dark,
      default: brand.gray.default,
      light: brand.gray.light,
      lighter: brand.gray.lighter,
      lightest: brand.gray.lightest,
      background: brand.gray.background,
    },
    tertiary: {
      darker: brand.orange.darker,
      dark: brand.orange.dark,
      default: brand.orange.default,
      light: brand.orange.light,
      lighter: brand.orange.lighter,
      lightest: brand.orange.lightest,
      background: brand.orange.background,
    },
    secondary: {
      darker: brand.blue.darker,
      dark: brand.blue.dark,
      default: brand.blue.default,
      light: brand.blue.light,
      lighter: brand.blue.lighter,
      lightest: brand.blue.lightest,
      background: brand.blue.background,
    },
    primary: {
      darker: brand.teal.darker,
      dark: brand.teal.dark,
      default: brand.teal.default,
      light: brand.teal.light,
      lighter: brand.teal.lighter,
      lightest: brand.teal.lightest,
      background: brand.teal.background,
    },
    danger: {
      darker: brand.red.darker,
      dark: brand.red.dark,
      default: brand.red.default,
      light: brand.red.light,
      lighter: brand.red.lighter,
      lightest: brand.red.lightest,
      background: brand.red.background,
    },
    accent: {
      brown: {
        dark: brand.brown.dark,
        default: brand.brown.default,
        light: brand.brown.light,
        background: brand.brown.background,
      },
      violet: {
        dark: brand.violet.dark,
        default: brand.violet.default,
        light: brand.violet.light,
        background: brand.violet.background,
      },
      pink: {
        dark: brand.pink.dark,
        default: brand.pink.default,
        light: brand.pink.light,
        background: brand.pink.background,
      },
      purple: {
        dark: brand.purple.dark,
        default: brand.purple.default,
        light: brand.purple.light,
        background: brand.purple.background,
      },
    },
    system: {
      dark: brand.system.dark,
      white: brand.system.default,
    },
  },
  mapped: {
    text: {
      heading: brand.gray.darker,
      subheading: brand.gray.dark,
      body: brand.gray.default,
      caption: brand.gray.default,
      success: brand.green.default,
      warning: brand.yellow.default,
      information: brand.blue.default,
      white: brand.system.default,
      label: brand.gray.default,
      overline: brand.gray.default,
      placeholder: brand.gray.light,
      disabled: brand.gray.lighter,
      footnote: brand.gray.dark,
    },
    surface: {
      default: brand.teal.default,
      hover: brand.teal.dark,
      active: brand.teal.darker,
      disabled: brand.gray.lighter,
      warningDefault: brand.yellow.default,
      warningHover: brand.yellow.dark,
      warningActive: brand.yellow.dark,
      errorDefault: brand.red.default,
      errorHover: brand.red.dark,
      errorActive: brand.red.darker,
      neutralDefault: brand.gray.default,
      neutralHover: brand.gray.dark,
      neutralActive: brand.gray.darker,
      neutralWhite: brand.system.default,
      systemWhite: brand.system.default,
      systemBlack: brand.system.dark,
    },
    borderBreaks: {
      primary: {
        default: brand.teal.default,
        hover: brand.teal.dark,
        active: brand.teal.darker,
        disabled: brand.gray.light,
        dark: brand.teal.dark,
        light: brand.teal.light,
      },
      neutral: {
        dark: brand.gray.lighter,
        default: brand.gray.lightest,
        naturalLight: brand.gray.background,
        naturalWhite: brand.system.default,
      },
      error: {
        dark: brand.red.darker,
        default: brand.red.default,
        light: brand.red.light,
      },
      warning: {
        dark: brand.yellow.dark,
        default: brand.yellow.default,
        light: brand.yellow.light,
      },
    },
    background: {
      primary: brand.orange.background,
      secondary: brand.system.default,
      danger: brand.red.background,
    },
    meals: {
      breakfast: brand.yellow.light,
      secondBreakfast: brand.yellow.default,
      snack: brand.green.light,
      brunch: brand.blue.light,
      afternoonSnack: brand.violet.light,
      secondAfternoonSnack: brand.violet.dark,
      preworkoutSnack: brand.purple.light,
      postWorkoutSnack: "#A87FD9",
      lunch: brand.blue.dark,
      dinner: brand.pink.light,
    },
  },
  // TODO: To be removed after alignment
  previous: {
    primary: "#1FD4AF",
  },
  black: "#000",
  dark: "#112340",
  subtitle: "#959A9F",
  error: "#FE5050",
  info: "#59B4FF",
  light: "#F5F7FA",
  primary: "#1FD4AF",
  secondary: "#FF9D37",
  white: "#FFF",
  borderColor: "#D4DBE5",
  blueBackground: brand.blue.background,
  gray: "#7D8797",
  grayLight: "#D3DBE5",
  grayLightest: brand.gray.lightest,
  grayLighter: brand.gray.lighter,
  grayLight300: "#e8eef8",
  grayLight400: "#DEE6F0",
  grayDark300: "#AAB0BB",
  tealLight500: "#1fd4af",
  text: "#112340",
  textHeadings: brand.gray.darker,
};
